import { PropsWithChildren } from "react";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";

interface Props extends PropsWithChildren {
  id: string;
  title: string;
  endSlot?: React.ReactNode;
}

export default function TabAccordion({ endSlot, id, title, children }: Props) {
  return (
    <Accordion
      sx={{
        "&:before": {
          display: "none",
        },
      }}>
      <AccordionSummary
        sx={{
          px: 3,
          "& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded":
            {
              my: 3,
              maxWidth: "100%",
            },
        }}
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${id}-content`}
        id={`${id}-header`}>
        <Stack direction="row" justifyContent="space-between" flexGrow={1}>
          <Typography
            sx={{ maxWidth: "fit-content", overflowWrap: "break-word" }}>
            {title}
          </Typography>
          {!!endSlot ? (
            <Box marginTop={-1} marginRight={2} justifySelf="flex-end">
              {endSlot}
            </Box>
          ) : (
            <></>
          )}
        </Stack>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
}
